module.exports = __webpack_public_path__ + "static/img/2011.8d802e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2011.png
// module id = /cZn
// module chunks = 1